import React from "react";
import { NoDataFoundTable } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import SplitPane from "react-split-pane";

const EventQueryHistory = () => {
  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        style={{ height: "-webkit-fill-available" }}
      >
        <NoDataFoundTable MSG={"Comming Soon..."} />
      </SplitPane>
    </>
  );
};

export default EventQueryHistory;
